import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M15.7059 16.8859L11.1259 12.2959L15.7059 7.7059L14.2959 6.2959L8.2959 12.2959L14.2959 18.2959L15.7059 16.8859Z" fill="#00011B"/>
</svg>
;
